





























import { Component, Vue } from 'vue-property-decorator';

import { EventUI } from '../../models/event-ui';
import { eventsStore } from '../../store';
import { eventUIStore } from '../../store/event-ui';
import EventSkeleton from './EventSkeleton.vue';

@Component({
  components: {
    EventSkeleton,
  },
})
export default class EventSection extends Vue {
  isLoading = true;

  eventUIs: EventUI[] = [];

  async mounted() {
    if (!eventsStore.events) {
      await eventsStore.fetch();
    }

    this.eventUIs =
      eventsStore.events &&
      eventsStore.events
        .sort(
          (eventA, eventB) =>
            new Date(((eventB as any).createdAt as any) || null).getTime() -
            new Date((eventA as any).createdAt || null).getTime(),
        )
        .map((event) => new EventUI(event));
    this.isLoading = false;
  }

  openEventPage(eventUI: EventUI) {
    eventUIStore.select(eventUI);

    return this.$router.push(eventUI.first_page);
  }
}
